export default "__VITE_ASSET__59bb5011__"